const Content = () => {
  return (
    <section class='relative py-16 bg-white min-w-screen animation-fade animation-delay'>
      <div class='container px-0 px-8 mx-auto sm:px-12 xl:px-5'>
        <h3 class='mt-1 text-2xl font-bold text-left text-gray-800 sm:mx-6 sm:text-3xl md:text-4xl lg:text-5xl sm:text-center sm:mx-0 text-center'>
          You can book a vehicle for your transfers
        </h3>
        <p class='mt-2 text-lg text-center text-gray-600'>
          Bandaranaike International Airport Colombo and City Taxi Transfers Sri
          Lanka
        </p>
        <div
          class='w-full px-6 py-6 mx-auto mt-10 bg-white rounded-lg sm:px-8 md:px-12 sm:py-8  lg:w-5/6 xl:w-2/3'
          data-aos='fade-up'
        >
          <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal text-justify'>
            We offer city and airport transfers in Sri Lanka from the Colombo
            International Airport to any location in the island. These airport
            transfers, city transfers and hotel transfers are available with a
            best rate guarantee for a certified service that ensures Euro NCAP
            certified vehicles with safety features including belts for all
            passengers, comprehensive ‘Rent A Car’ Insurance Cover (a legal
            requirement), Sri Lanka Tourist Board and ISO 9001 Certification.
            Our driver will meet you at the arrival terminal of the airport
            carrying your name-board and thereafter transport you to your
            desired location. You also have the option of retaining the vehicle
            and the driver for the rest of your trip if required. You will be
            guaranteed a pre-determined price depending on destination based on
            the standard pricing formula as well as a driver and vehicle of a
            certified standard. You will also have the benefit of not having to
            go through the hassle of dealing with touts and brokers at the
            airport. Our service is especially convenient if your arrival or
            departure is at a late or early hour when airport transport options
            are limited. Transport arrangements can also be made for transit
            passengers arriving in Sri Lanka.
            <br />
            <br />
            We offer best guaranteed rates for taxi and city or hotel transfer
            from and to leading hotels including The Cinnamon Grand, Cinnamon
            Lakeside, Cinnamon Red, The Kingsbury Hotel, Hilton Colombo, Hilton
            Residencies, The Galle Face Hotel, Mount Lavinia Hotel, OZO Colombo,
            Shangri-La Colombo, Jetwing Colombo Seven, ITC Hotels Colombo,
            Ramada Colombo, Hyatt Regency in Colombo. We also handle city and
            taxi transfers to and from holiday resorts including Cinnamon
            Hotels, Shangri-La Hambantota, Chaaya Resorts, Jetwing Hotels,
            Heritance Hotels, Uga Bay Resorts, Cape Weligama, Anilana Hotels in
            Kandy, Anantara Resorts and cities including Galle, Dambulla,
            Hambantota, Arugam Bay, Pasikudah, Kalkudah, Trincomalee,
            Batticaloa, Yala, Ella, Nuwara Eliya, Mirissa, Kalpitiya to and back
            to the Bandaranaike International Airport, Colombo or simply city to
            city transfers.
          </p>
          <ul class='list-disc p-10'>
            <li class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              You will get a comfortable luxury vehicle
            </li>
            <li class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Very Reasonable bottom prices
            </li>
            <li class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              English Speeking Profecinal Drivers
            </li>
            <li class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Registered vehicles with a Airport Aviation of Sri lanka
            </li>
            <li class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              You will get official cash receipt
            </li>
            <li class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              You can pay by Dollers or SL rupees
            </li>
            <li class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              You can go through Express ways quikly to your place, it's
              including toll charge
            </li>
            <li class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Representative will Waite with a name board in arrival lobby area
            </li>
            <li class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              No need to pay advance
            </li>
            <li class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Fully responsible service
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Content;
